import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'convfact-payment-history-dialog',
    templateUrl: './payment-history-dialog.component.html',
    styleUrls: ['./payment-history-dialog.component.css'],
    standalone: false
})
export class PaymentHistoryDialogComponent implements OnInit {

  paymentHistory: any[] = [];
  pageSize = 8;
  currentPage = 1;

  constructor(
    public dialogRef: MatDialogRef<PaymentHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.paymentHistory = data && data.paymentHistory ? data.paymentHistory : [];
  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.paymentHistory.length / this.pageSize));
  }

  get pagedHistory(): any[] {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.paymentHistory.slice(start, start + this.pageSize);
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
  }

  getStatusLabel(status: string): string {
    const statusMap: { [key: string]: string } = {
      'draft': 'Borrador',
      'open': 'Abierto',
      'paid': 'Pagado',
      'uncollectible': 'No cobrable',
      'void': 'Anulado'
    };
    const key = status && status.toLowerCase ? status.toLowerCase() : status;
    return statusMap[key] || status;
  }

  getStatusClass(status: string): string {
    const classMap: { [key: string]: string } = {
      'draft': 'status-draft',
      'open': 'status-open',
      'paid': 'status-paid',
      'uncollectible': 'status-uncollectible',
      'void': 'status-void'
    };
    const key = status && status.toLowerCase ? status.toLowerCase() : status;
    return classMap[key] || '';
  }

  public trackByIndex(i: number) { return i; }

}
